import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SECTION_PATH_TO_ID } from '../../pages/LandingPage/sectionPaths';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (SECTION_PATH_TO_ID[pathname]) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
